import $ from 'jquery';

// const $form = $('#listings-filter-form');

$('body').on('click', '.js-remove-filter', function () {
    let $input = $('input#' + $(this).data('filter')).prop('checked', false);
    $(this).parent('li').remove();
    $input.closest('form').submit();
});
